<template>
  <div id="J_userMenu" class="user-address-menu">
    <div class="menu-box" v-if="is_admin">
      <h3 class="title">企业管理</h3>
      <ul class="list">
        <li :class="getActiveClass('enterprice/order')">
          <a @click="onClick('enterprice/order')">订单查询</a>
        </li>
        <li :class="getActiveClass('account')">
          <a @click="onClick('account')">子账号管理</a>
        </li>
      </ul>
    </div>
    <div class="menu-box">
      <h3 class="title">订单中心</h3>
      <ul class="list">
        <li :class="getActiveClass('inquiry/order')">
          <a @click="onClick('inquiry/order')">询价单</a>
        </li>
        <li :class="getActiveClass('order')">
          <a @click="onClick('order')">采购单</a>
        </li>
      </ul>
    </div>
    <div class="menu-box">
      <h3 class="title">个人中心</h3>
      <ul class="list">
        <li :class="getActiveClass('profile')">
          <a @click="onClick('profile')">个人中心</a>
        </li>
        <li :class="getActiveClass('message')">
          <a @click="onClick('message')" :class="getActiveClass"
            >消息通知<i class="J_miMessageTotal"></i
          ></a>
        </li>
        <li :class="getActiveClass('like')">
          <a @click="onClick('like')">收藏夹</a>
        </li>
        <li :class="getActiveClass('address')">
          <a @click="onClick('address')">收货地址</a>
        </li>
      </ul>
    </div>
    <div class="menu-box">
      <h3 class="title">售后服务</h3>
      <ul class="list">
        <li :class="getActiveClass('service')">
          <a @click="onClick('service')" :class="getActiveClass">服务记录 </a>
        </li>
      </ul>
    </div>
    <div class="menu-box">
      <h3 class="title">账户管理</h3>
      <ul class="list">
        <li :class="getActiveClass('info')">
          <a @click="onClick('info')" target="_blank">个人信息</a>
        </li>
        <li :class="getActiveClass('password')">
          <a
            @click="onClick('password')"
            target="_blank"
            :class="getActiveClass"
            >修改密码
          </a>
        </li>
        <li :class="getActiveClass('pay_password')">
          <a
            @click="onClick('pay_password')"
            target="_blank"
            :class="getActiveClass"
            >支付密码
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { session } from "@/assets/js/util.js";
export default {
  name: "LeftNav",
  data() {
    return {
      is_admin: false,
      active: session.get("left_nav"),
    };
  },
  mounted() {
    if (!session.get("left_nav")) {
      session.set("left_nav", "profile");
    }
    if (session.get("pid") === 0) {
      this.is_admin = true;
    } else {
      this.is_admin = false;
    }
  },
  methods: {
    getActiveClass(menu) {
      if (this.active === menu) {
        return "active";
      }
    },
    onClick(menu) {
      this.active = menu;
      session.set("left_nav", menu);
      this.$router.push({ path: "/" + menu });
    },
  },
};
</script>
